const i = {
  display: "inline-flex",
  alignItems: "center",
  gap: "spacing-2",
  backgroundColor: "alpha-black-10",
  color: "text-primary"
}, a = {
  sm: {
    paddingTop: "spacing-0,5",
    paddingBottom: "spacing-0,5",
    paddingLeft: "spacing-1,5",
    paddingRight: "spacing-1,5",
    borderRadius: "radius-1,5",
    fontSize: "sm",
    fontWeight: "medium"
  },
  md: {
    paddingTop: "spacing-1",
    paddingBottom: "spacing-1",
    paddingLeft: "spacing-2",
    paddingRight: "spacing-2",
    borderRadius: "radius-2",
    fontSize: "sm",
    fontWeight: "medium"
  },
  lg: {
    paddingTop: "spacing-1,5",
    paddingBottom: "spacing-1,5",
    paddingLeft: "spacing-2",
    paddingRight: "spacing-2",
    borderRadius: "radius-2",
    fontSize: "md",
    fontWeight: "medium"
  }
}, o = {
  neutral: {
    backgroundColor: "alpha-black-10",
    color: "text-primary"
  },
  flat: {
    borderWidth: 1,
    borderColor: "alpha-black-10",
    backgroundColor: "bg-secondary",
    color: "text-primary"
  },
  glassy: {
    borderWidth: 1,
    borderColor: "alpha-white-30",
    backgroundColor: "alpha-white-50",
    color: "text-white",
    backdropFilter: "blur-5"
  }
}, d = {
  sm: {
    size: 12
  },
  md: {
    size: 14
  },
  lg: {
    size: 16
  }
}, n = {
  base: i,
  size: a,
  variant: o,
  iconSize: d
};
export {
  n as badgeRecipe
};
